export const VEHICLES = [
  {
    id: 1,
    model: "Toyota Hiace Commuter",
    year: 2025,
    type: "Van",
    seats: 12,
    image_url: "/images/hiace-2025/1-PHOTO-2026-04-26-01-14-33.jpg",
    price_per_day: 0,
  },
  {
    id: 2,
    model: "Toyota Hiace Commuter",
    year: 2015,
    type: "Van",
    seats: 12,
    image_url: "/images/hiace-2015/1-PHOTO-2026-04-26-01-14-35 2.jpg",
    price_per_day: 0,
  },
  {
    id: 3,
    model: "Toyota Tarago",
    year: 2020,
    type: "Van",
    seats: 8,
    image_url: "/images/tarago-2020/22_2451.jpg",
    price_per_day: 0,
  },
];
